module.exports = __webpack_public_path__ + "img/DE02162.3d994b0e.png";